import SubserviceWrapper from "../../../components/Subservice/SubserviceWrapper";
import services from "../../../service.map";

import "./styles/pjw.styles.css";

export const PJW = () => {
	return <SubserviceWrapper config={services.pjwrg} />;
};
